module.exports = __webpack_public_path__ + "static/Women-Computer-Science-Engineering-Progeam-800x500-7d4e46d0ac97b7e8efe539bf3126c577.jpg";